import { useEffect, useState } from "react";
import MDEditor from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import { THEME_EVENT, getResolvedTheme } from "../utility/theme";

/* Read-only markdown, set in `.typeset` (theme.css). rehype-sanitize strips
   raw HTML that could run script (an <img onerror>, a javascript: link), so
   a description is safe to show to every employee on the project. Plain text
   from before the editor existed renders as paragraphs. data-color-mode
   keeps code-block colours on the app's mode rather than the OS's. */
const MarkdownView = ({ source, className = "" }) => {
  const [colorMode, setColorMode] = useState(getResolvedTheme);
  useEffect(() => {
    const onThemeChange = (e) => setColorMode(e.detail.resolved);
    window.addEventListener(THEME_EVENT, onThemeChange);
    return () => window.removeEventListener(THEME_EVENT, onThemeChange);
  }, []);

  return (
    <MDEditor.Markdown
      source={source || ""}
      className={("typeset " + className).trim()}
      rehypePlugins={[[rehypeSanitize]]}
      wrapperElement={{ "data-color-mode": colorMode }}
    />
  );
};

export default MarkdownView;
